
<template>
    <div v-if="showModel" class="edit-model">
        <div class="img-div">
            <div>{{title}}</div>
            <div class="close-img" @click="cancel"><i class="iconfont">&#xe641;</i></div>
        </div>
       
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="问题" prop="title">
                <Input type="text" placeholder="你今年的多大了?" v-model="formData.title"></Input>
            </FormItem>
            <FormItem label="选项" prop="options" class="ivu-form-item-required">
                <div class="option-div">
                    <div class="title">
                        <div>请添加问题选项</div>
                        <div><Button type="info" size="small" @click="addOP">添加</Button></div>
                    </div>
                    <div class="list">
                        <div class="item" v-for="(item,index) in optionsList" :key="index">
                            <div class="tit"><Input style="width: 100%" type="text" placeholder="例如：A" v-model="item.id"></Input></div>
                            <div class="name"><Input style="width: 100%" type="text" placeholder="例如：15岁？" v-model="item.cont"></Input></div>
                            <div class="btnq">
                                <Button type="error" size="small" @click="delOp(item,index)">删除</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </FormItem>
            <FormItem label="所属问卷" prop="question_id" class="ivu-form-item-required">
                <SearchModelNew   v-model="formData.question_id" :isMultiple="2"
              :url="config.urlArray.questionShowQuestion"
              labelName="title"
              valName="id"
              keyword="keyword" placeholderText="请输入"  ></SearchModelNew>
            </FormItem>
            <FormItem label="类型" prop="type" class="ivu-form-item-required">
                <RadioGroup v-model="formData.type">
                    <Radio label="1">选择题</Radio>
                    <!-- <Radio label="2">判断题</Radio>
                    <Radio label="3">简答题</Radio> -->
                </RadioGroup>
            </FormItem>
            <FormItem label="题型" prop="mut" class="ivu-form-item-required">
                <RadioGroup v-model="formData.mut">
                    <Radio label="1">单选</Radio>
                    <Radio label="2">多选</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="状态" prop="status" class="ivu-form-item-required">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">启用</Radio>
                    <Radio label="2">禁用</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="排序" prop="sort">
                <Input type="text" v-model="formData.sort"></Input>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  name: "Model1",
  components: {
  },
  data() {
    return {
      title: "添加/编辑",
      disabled: false,
      defaultData:{
        id: '',
        title: "",
        options: "",
        type: "1",
        question_id: "",
        status: "1",
        sort: "100",
        mut:'1'
      },
     
      optionsList:[
          {id: '', cont: '',}
      ],
      formData: {},
      ruleCustom: {
        //验证
        title: [
          { required: true, message: "问题必须填写", trigger: "blur" },
        ],
        sort: [
          { required: true, message: "排序必须填写", trigger: "blur" },
        ],
       
      },
      
    };
  },
  watch: {
    showModel(val) {
		if(val){
			if (this.type && this.type == 2) {
				this.editForm()
			}
			if(this.type && this.type == 1){
				this.formData = this.defaultData
			}
		}
    },
  },
  methods: {
    addOP(){
        let obj = {id: '', cont:''}
        this.optionsList.push(obj)
    },
    delOp(item,index){
        this.optionsList.splice(index,1)
    },
    editForm() {
	  for(let key in this.defaultData){
		  this.formData[key]=(this.editFormData[key] instanceof Array || this.editFormData[key] instanceof Object )?this.editFormData[key] : String(this.editFormData[key])
		  if(!this.editFormData[key]){
		    this.formData[key] = ''
          } 
        //   this.formData.options = JSON.parse(this.formData.options)
          let options =  this.formData.options
        //   let options =  {"1":"333","2":"555"}
          this.optionsList = []
          for(let key in options){
              let obj = {id: key, cont: options[key]}
              this.optionsList.push(obj)
          }

          console.log(this.formData)
          console.log(this.optionsList)
	  }
    },
    subData(name) {
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
          if(!this.formData.question_id){
              common.msg("error", "请所属问卷", () => {
                this.disabled = false;
              });
          }
          let options = {}
          this.optionsList.map((item,index)=>{
              options[item.id] = item.cont
          })
          this.formData.options = options
          this.axios
            .post(this.config.urlArray.questionTitleStore, this.formData)
            .then(result => {
              common.ajaxMsg(
                result.data,
                true,
                () => {
                  //提交表单后的回调处理
                  this.resetForm(); //重置表单
                  this.fn();
                },
                () => {
                  this.disabled = false;
                }
              );
            })
            .catch(err => {
              common.msg("error", "提交失败", () => {
                this.disabled = false;
              });
            });
        }
      });
    },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.resetForm()
      this.fn();
    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
        this.formData = this.defaultData
      //重置表单
      this.formData.id = '';
      this.optionsList = [  {id: '', cont: ''}   ],
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model{
    position: relative;
    .img-div{
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 45px;
        div{
            font-weight: bold;
            font-size: 15px;
        }
    }
    .close-img{
        border: 1px solid #fd6363;
        display: inline-block;
        line-height: 100%;
        border-radius: 100%;
        padding: 5px;
        color: #f00;
        right: 10px;
        top: 10px;
        z-index: 3;
        cursor: pointer;
    }
    .close-img:hover{
        transform: scale(1.1);
        transition: all 0.3s;
    }
}
.option-div{
    padding: 10px;
    box-sizing: border-box; 
    .title{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .list{
        margin-top: 10px;
        .item{
            display: flex;
            align-items: center;
            justify-content: space-between;
            div{
                // flex: 1;
            }
            .tit{
                width: 100px;
                margin-right: 10px;
            }
            .name{
                flex: 1;
            }
            .btnq{
                width: 100px;
                display: flex;
                justify-content: flex-end;
            }
            
        }
    }
}
</style>